<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Aliado</v-btn>
      </template>
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <progress-bar :show="form.busy"></progress-bar>
            <form @submit.prevent="createDocument" @keydown="form.onKeydown($event)">
              <v-card-title primary-title>
                <h3 v-if="!editingAllied" class="headline mb-0">
                  {{ $t("enrollments.allies.create-title") }}
                </h3>
                <h3 v-else class="headline mb-0">
                  {{ $t("enrollments.allies.update-title") }}
                </h3>
              </v-card-title>

              <v-card-text>
                <text-input :form="form" label="Nombre" :v-errors="errors" :value.sync="form.name"
                  name="name"></text-input>

                <text-area-input :form="form" label="Descripción" :v-errors="errors" :value.sync="form.description"
                  name="description"></text-area-input>

                <div class="upload">
                  <ul>
                    <li v-for="photo in photos" :key="photo.id">
                      <span>{{ photo.name }}</span> -
                      <span>{{ photo.size }}</span>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        <v-tooltip top>
                          <v-icon small class="mr-2" @click.prevent="$refs.upload1.remove(photo)" slot="activator">
                            delete
                          </v-icon>
                          <span>{{
      $t("enrollments.allies.delete-button")
    }}</span>
                        </v-tooltip>
                      </span>
                    </li>
                  </ul>
                  <!-- <span>Banner</span>
                  <div class="example-btn">
                    <file-upload
                      class="mb-2 v-btn theme--dark primary"
                      extensions="gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp"
                      :multiple="false"
                      :size="1024 * 1024 * 10"
                      v-model="photos"
                      @input-filter="inputFilter"
                      @input-file="inputFile"
                      ref="upload1"
                    >
                      <i class="fa fa-plus"></i>
                      Seleccionar Archivo
                    </file-upload>
                    <span v-if="filesError" class="red--text"
                      >Debe cargar archivo</span
                    >
                  </div> -->
                </div>
                <text-input :form="form" label="URL Aliado" :v-errors="errors" :value.sync="form.url"
                  name="url"></text-input>

                <div class="upload">
                  <ul>
                    <li v-for="file in files" :key="file.id">
                      <span>{{ file.name }}</span> -
                      <span>{{ file.size }}</span>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        <v-tooltip top>
                          <v-icon small class="mr-2" @click.prevent="$refs.upload.remove(file)" slot="activator">
                            delete
                          </v-icon>
                          <span>{{
      $t("enrollments.allies.delete-button")
    }}</span>
                        </v-tooltip>
                      </span>
                    </li>
                  </ul>
                  <span>foto aliado</span>
                  <div class="example-btn">
                    <file-upload class="mb-2 v-btn theme--dark primary" extensions="gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp" :multiple="false" :size="1024 * 1024 * 10"
                      v-model="files" @input-filter="inputFilter" @input-file="inputFile" ref="upload">
                      <i class="fa fa-plus"></i>
                      Seleccionar Archivo
                    </file-upload>
                    <span v-if="filesError" class="red--text">Debe cargar archivo</span>
                  </div>
                </div>

                <check-input :form="form" label="Aliado externo" :v-errors="errors" :value.sync="form.company"
                  name="company" v-validate="'required'"></check-input>

                <check-input :form="form" label="Habilitado para pago" :v-errors="errors"
                  :value.sync="form.enable_for_payment" name="enable_for_payment" v-validate="'required'"></check-input>

                <check-input :form="form" label="Pago parcial" :v-errors="errors"
                  :value.sync="form.allow_partial_payment" name="allow_partial_payment" v-validate="'required'"
                  :disabled="partialCheckEnabled"></check-input>

                <text-input :form="form" label="URL Wompi" :v-errors="errors" :value.sync="form.wompi_url"
                  name="wompi_url"></text-input>

                <text-input :form="form" label="Llave pública" :v-errors="errors" :value.sync="form.wompi_public_key"
                  name="wompi_public_key"></text-input>

                <text-area-input :form="form" label="Cuerpo Email para confirmación" :v-errors="errors"
                  :value.sync="form.email_body" name="email_body"></text-area-input>

                <check-input :form="form" label="Activo" :v-errors="errors" :value.sync="form.status" name="status"
                  v-validate="'required'"></check-input>
              </v-card-text>

              <v-card-actions>
                <submit-button v-if="!editingAllied" :form="form"
                  :label="$t('enrollments.allies.save-button')"></submit-button>
                <submit-button v-else :form="form" :label="$t('enrollments.allies.update-button')"></submit-button>
                <v-btn @click="cancelFormSubmit">{{
      $t("enrollments.allies.cancel-button")
    }}</v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout row>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="allies" class="elevation-1 mt-3">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.url }}</td>
            <td class="text-xs-center">
              {{ props.item.company == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.enable_for_payment == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.allow_partial_payment == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.status == 1 ? "Si" : "No" }}
            </td>
            <td class="text-xs-center">{{ props.item.wompi_url }}</td>
            <td class="text-xs-center">{{ props.item.wompi_public_key }}</td>
            <td class="text-xs-center">{{ props.item.email_body }}</td>
            <td>
              <v-tooltip top>
                <v-icon medium class="mr-2" @click="editDocument(props.item.id)" slot="activator">
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip v-if="props.item.enable_for_payment == 1" top>
                <v-icon medium class="mr-2" @click="showAlliesCosts(props.item)" slot="activator">
                  monetization_on
                </v-icon>
                <span>Ver Costos</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon medium class="mr-2" @click="deleteDocument(props.item.id)" slot="activator">
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="fileDialog" max-width="600px">
      <template>
        <v-layout>
          <v-flex xs12>
            <object :data="path_file" width="600px" height="500px"></object>
          </v-flex>
        </v-layout>
      </template>
    </v-dialog>
    <v-dialog v-model="showAlliesCostsModal" scrollable fullscreen persistent :overlay="false" max-width="600px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showAlliesCostsModal = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ allyCosts.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <allies-costs :ally="allyCosts"> </allies-costs>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from "vform";
import axios from "axios";
import FileUpload from "vue-upload-component";
import alliesCosts from "./allies_costs";
export default {
  name: "enrollment-document-create-view",
  components: {
    FileUpload,
    "allies-costs": alliesCosts
  },
  data() {
    return {
      form: new Form({
        name: "",
        description: "",
        photos: [],
        url: "",
        company: false,
        status: false,
        enable_for_payment: false,
        allow_partial_payment: false,
        wompi_url: "",
        wompi_public_key: "",
        email_body: ""
      }),
      headers: [
        { text: "Nombre", align: "center", value: "start_date" },
        { text: "Descripción", align: "center", value: "description" },
        { text: "URL", align: "center", value: "start_date" },
        { text: "Externo", align: "center", value: "digital_id_documet" },
        { text: "Hab. Pago", align: "center", value: "enable_for_payment" },
        {
          text: "Pago Parcial",
          align: "center",
          value: "allow_partial_payment"
        },
        { text: "Activo", align: "center", value: "family" },
        { text: "Wompi URL", align: "center", value: "wompi_url" },
        { text: "Wompi PK", align: "center", value: "wompi_public_key" },
        { text: "Email", align: "center", value: "email_body" },
        { text: "Acciones", align: "center", value: "acciones" }
      ],
      files: [],
      editingAllied: false,
      filesError: false,
      fileDialog: false,
      path_file: "",
      dialog: false,
      allies: [],
      allyCosts: {},
      showAlliesCostsModal: false
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    partialCheckEnabled() {
      return !this.form.enable_for_payment;
    }
  },
  methods: {
    async initialize() {
      const allies = await axios.get("/api/enrollments/allies");
      this.allies = allies.data;
    },

    async createDocument() {
      if (await this.formHasErrors()) return;
      if (this.editingAllied) {
        this.updateDocument();
        return;
      }
      this.filesError = false;
      if (this.files.length === 0) {
        this.filesError = true;
        return;
      }
      const { data } = await this.form.post("/api/enrollments/allies");

      if (data.error) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: this.$t("enrollments.allies.stored-error-text"),
          title: this.$t("enrollments.allies.stored-error-title"),
          modal: true
        });
      } else {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: this.$t("enrollments.allies.stored-ok-text"),
          title: this.$t("enrollments.allies.stored-ok-title"),
          modal: true
        });

        // this.uploadFile(data.id);
        if (this.files.length > 0) {
          // console.log(this.form.id);
          this.uploadFile(this.form.id);
        }
        // if (this.photos.length > 0) {
        //   this.uploadFile(this.form.id, "photo");
        // }

        this.dialog = false;
        this.initialize();
        this.form.clear();
        this.form.reset();
      }
    },
    async updateDocument() {
      const { data } = await this.form.put("/api/enrollments/allies");

      if (data.error) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: this.$t("enrollments.allies.stored-error-text"),
          title: this.$t("enrollments.allies.stored-error-title"),
          modal: true
        });
      } else {
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: this.$t("enrollments.allies.stored-ok-text"),
          title: this.$t("enrollments.allies.stored-ok-title"),
          modal: true
        });
        if (this.files.length > 0) {
          this.uploadFile(this.form.id);
        }
        // if (this.photos.length > 0) {
        //   this.uploadFile(this.form.id, 'photo');
        // }
        this.dialog = false;
        this.editingAllied = false;
        this.initialize();
        this.form.clear();
        this.form.reset();
      }
    },
    editDocument(id) {
      this.dialog = true;
      const alliedToEdit = this.allies.filter(allied => allied.id === id)[0];
      this.editingAllied = true;
      this.form = new Form({
        name: alliedToEdit.name,
        description: alliedToEdit.description,
        photos: alliedToEdit.photos,
        url: alliedToEdit.url,
        wompi_url: alliedToEdit.wompi_url,
        wompi_public_key: alliedToEdit.wompi_public_key,
        email_body: alliedToEdit.email_body,
        company: alliedToEdit.company == 1,
        status: alliedToEdit.status == 1,
        enable_for_payment: alliedToEdit.enable_for_payment == 1,
        allow_partial_payment: alliedToEdit.allow_partial_payment == 1,
        id
      });
    },
    deleteDocument(id) {
      axios
        .delete(`/api/enrollments/allied/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.allies = this.allies.filter(allied => allied.id !== id);
            this.$store.dispatch("responseMessage", {
              type: "success",
              text: "Eliminado correctamente",
              modal: false
            });
          }
        })
        .catch(error => console.log(error));
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log("add", newFile);
      }
      if (newFile && oldFile) {
        // update
        console.log("update", newFile);
      }
      if (!newFile && oldFile) {
        // remove
        console.log("remove", oldFile);
      }
    },
    uploadFile(id, type = 'file') {
      let formData = new FormData();
      let fileData;
      if (type === 'file' && this.files.length > 0) {
        this.files.forEach((file, index) => {
          fileData = this.$refs.upload.get(file.id);
          formData.append(`file_${index}`, fileData.file);
        });
        formData.append("allie_id", id);
        axios
          .post(`/api/enrollments/allies/file`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(resp => {
            if (resp.status === 200) {
              this.$store.dispatch("responseMessage", {
                type: "success",
                text: "Archivo guardado",
                modal: false
              });
              this.$refs.upload.clear();
              this.$refs.upload1.clear();
            }
          })
          .catch(error => console.log(error));
      }
      // if (type === 'photo' && this.photos.length > 0 ) {
      //   this.photos.forEach((photo, index) => {
      //     fileData = this.$refs.upload1.get(photo.id);
      //     formData.append(`photo_${index}`, fileData.file);
      //   });
      // }
      formData.append("allie_id", id);
      // axios
      //   .post(`/api/enrollments/allies/file_banner`, formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(resp => {
      //     if (resp.status === 200) {
      //       this.$store.dispatch("responseMessage", {
      //         type: "success",
      //         text: "Archivo guardado",
      //         modal: false
      //       });
      //       this.$refs.upload.clear();
      //       this.$refs.upload1.clear();
      //     }
      //   })
      //   .catch(error => console.log(error));
    },

    showTemplate(path) {
      this.path_file = path;
      this.fileDialog = true;
    },
    cancelFormSubmit() {
      this.editingAllied = false;
      this.dialog = false;
      this.form = new Form({
        name: "",
        description: "",
        // photos: [],
        url: "",
        wompi_url: "",
        wompi_public_key: "",
        email_body: "",
        company: false,
        status: false,
        enable_for_payment: false,
        allow_partial_payment: false
      });
    },
    showAlliesCosts(ally) {
      this.allyCosts = { ...ally };
      this.showAlliesCostsModal = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/allies.vue